import auth from './auth';
export default auth;



// WEBPACK FOOTER //
// ./src/services/auth/index.js